import { FETCH_RECIPES } from "../actions/types";

const recipes = (state = [], action) => {
  switch (action.type) {
    case FETCH_RECIPES:
      return action.payload;
    default:
      return state;
  }
};

export default recipes;
